import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ServicesService } from 'src/services/services.service';
import * as QRCode from 'qrcode';

type DisplayField = {
  label: string;
  value: string;
};

@Component({
  selector: 'app-idcard2',
  templateUrl: './idcard2.component.html',
  styleUrls: ['./idcard2.component.scss'],
  standalone: false
})
export class Idcard2Component implements OnInit, AfterViewInit {
  @Input() isSelected: boolean = false;
  @ViewChildren('qrcodeCanvas') qrCodeCanvases!: QueryList<ElementRef<HTMLCanvasElement>>;

  card_data: any;
  card_image: string = '';
  reg_setting_data: any;
  fields: any[] = [];
  event_id: any;
  mem_id: any;
  ticket_print: any = 'single';
  ticketCards: any[] = [];
  qrData: { [key: string]: string } = {};
  showData: { [key: string]: string } = {};

  defaultImage: string = 'https://aieventzo.com/upload/event_logo/66a0e18c3d4d9.png';
  cardWidth: number = 350;
  cardHeight: number = 500;
  cardX: number = 10;
  cardY: number = 240;
  qrWidth: number = 120;
  qrHeight: number = 120;
  fontSize: number = 20;
  layout: string = 'horizontal';
  color: string = '#000000';
  scanType: string = 'qrcode';
  content: string = 'yes';
  companyAd: string = 'off';
  companyAdText: string = '';
  pdf_bg: string = 'no';

  private viewReady: boolean = false;
  private cardReady: boolean = false;
  private regReady: boolean = false;
  private settingReady: boolean = false;
  private imageReady: boolean = false;
  private hasPrinted: boolean = false;

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute
  ) { }

  get footerFontSize(): number {
    return Math.max(12, Math.round(this.cardHeight * 0.028));
  }

  get footerPaddingY(): number {
    return Math.max(4, Math.round(this.cardHeight * 0.012));
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const event_id = params.get('event_id');
      const mem_id = params.get('mem_id');

      if (event_id && mem_id) {
        this.Get_Card(event_id);
        this.get_reg_setting_for_icard(event_id, mem_id);
        this.Get_Setting(event_id);
      }
    });
  }

  ngAfterViewInit() {
    this.viewReady = true;
    this.qrCodeCanvases.changes.subscribe(() => this.tryRenderAndPrint());
    this.tryRenderAndPrint();
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.defaultImage;
    this.imageReady = true;
    this.tryRenderAndPrint();
  }

  onCardImageLoad(): void {
    this.imageReady = true;
    this.tryRenderAndPrint();
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getDisplayEntries(ticket: any = null): DisplayField[] {
    const entries: DisplayField[] = [];

    if (this.mem_id) {
      entries.push({ label: 'Id', value: `${this.mem_id}` });
    }

    if (ticket?.category) {
      entries.push({ label: 'Ticket Category', value: `${ticket.category}` });
    }

    Object.keys(this.showData).forEach((key) => {
      if (ticket?.category && key === 'Ticket Category') {
        return;
      }

      const value = this.showData[key];
      if (value !== undefined && value !== null && `${value}`.trim() !== '') {
        entries.push({ label: key, value: `${value}` });
      }
    });

    return entries;
  }

  isNameField(label: string): boolean {
    const normalized = `${label}`.trim().toLowerCase();
    return normalized === 'name' || normalized === 'full name';
  }

  getBarcodeValue(ticket: any = null): string {
    return this.qrData['barcode'] || this.mem_id || ticket?.category || '';
  }

  Get_Card(event_id: any) {
    this.service.get_card(event_id).subscribe((data: any) => {
      const card = data.data?.[0] || {};

      this.card_data = data.data;
      this.imageReady = false;
      this.card_image = card.image1 ? `https://aieventzo.com/upload/icard/${card.image1}` : this.defaultImage;
      this.cardWidth = Number(card.width) || 350;
      this.cardHeight = Number(card.height) || 500;
      this.cardX = Number(card.x_axis) || 10;
      this.cardY = Number(card.y_axis) || 240;
      this.qrWidth = Number(card.qr_width) || 120;
      this.qrHeight = Number(card.qr_height) || 120;
      this.fontSize = Number(card.font_size) || 20;
      this.layout = card.layout || 'horizontal';
      this.color = card.color || '#000000';
      this.scanType = card.scan_type || 'qrcode';
      this.content = card.content || 'yes';
      this.companyAd = card.company_ad || 'off';
      this.companyAdText = card.company_ad_text || '';
      this.pdf_bg = card.pdf_bg || 'no';

      this.cardReady = true;
      this.tryRenderAndPrint();
    });
  }

  get_reg_setting_for_icard(event_id: any, mem_id: any) {
    this.service.get_reg_setting_for_icard(event_id, mem_id).subscribe({
      next: (data: any) => {
        this.reg_setting_data = data;
        this.event_id = data.event_id;
        this.mem_id = data.mem_id;
        this.fields = data.fields || [];
        this.ticketCards = [];
        this.showData = {};
        this.qrData = {};

        this.fields.forEach((field: any) => {
          if (field.field === 'tic_category') {
            try {
              const tickets = JSON.parse(field.value);
              tickets.forEach((ticket: any) => {
                for (let i = 0; i < ticket.quantity; i++) {
                  this.ticketCards.push({ category: ticket.category });
                }
              });
            } catch (error) {
              console.error('Failed to parse tic_category:', error);
            }
          }

          this.showData[field.label] = field.value;
          this.qrData[field.field] = field.value;
        });

        this.qrData['event_id'] = this.event_id;
        this.qrData['mem_id'] = this.mem_id;

        this.regReady = true;
        this.tryRenderAndPrint();
      },
      error: (error: any) => {
        console.error('Error fetching reg setting:', error);
      }
    });
  }

  Get_Setting(eventId: any) {
    this.service.getsetting(eventId).subscribe((data: any) => {
      this.ticket_print = data.data?.[0]?.ticket_print || 'single';
      this.settingReady = true;
      this.tryRenderAndPrint();
    });
  }

  private expectedCanvasCount(): number {
    if (this.content === 'no' || this.scanType !== 'qrcode') {
      return 0;
    }

    return this.ticket_print === 'multiple' ? this.ticketCards.length : 1;
  }

  private buildQrPayload(ticket: any = null): string {
    const payload = { ...this.qrData };

    if (ticket?.category) {
      payload['ticket_category'] = ticket.category;
    }

    return JSON.stringify(payload);
  }

  private renderCodes(): Promise<void> {
    if (this.content === 'no' || this.scanType !== 'qrcode') {
      return Promise.resolve();
    }

    const canvases = this.qrCodeCanvases?.toArray() || [];
    const qrSize = Math.max(this.qrWidth, this.qrHeight, 64);

    return Promise.all(
      canvases.map((canvasRef, index) => {
        const ticket = this.ticket_print === 'multiple' ? this.ticketCards[index] : null;
        const canvas = canvasRef.nativeElement;

        canvas.width = qrSize;
        canvas.height = qrSize;

        return new Promise<void>((resolve) => {
          QRCode.toCanvas(
            canvas,
            this.buildQrPayload(ticket),
            {
              width: qrSize,
              margin: 0,
              errorCorrectionLevel: 'H'
            },
            (error) => {
              if (error) {
                console.error('Error generating QR code:', error);
              }
              resolve();
            }
          );
        });
      })
    ).then(() => undefined);
  }

  private tryRenderAndPrint(): void {
    if (!this.viewReady || !this.cardReady || !this.regReady || !this.settingReady || !this.imageReady || this.hasPrinted) {
      return;
    }

    const expectedCanvases = this.expectedCanvasCount();
    if (expectedCanvases > 0 && (this.qrCodeCanvases?.length || 0) < expectedCanvases) {
      return;
    }

    setTimeout(() => {
      if (this.hasPrinted) {
        return;
      }

      const canvasCount = this.qrCodeCanvases?.length || 0;
      if (expectedCanvases > 0 && canvasCount < expectedCanvases) {
        return;
      }

      this.renderCodes().then(() => {
        this.hasPrinted = true;
        window.print();
      });
    }, 250);
  }
}
